import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { PBXService } from 'src/app/services/pbx.service';

import { DidsService } from '../dids/dids.service';
import { SessionService } from '../shell/session.service';

export const callHistoryResolver: ResolveFn<void> = () => {
  const session = inject(SessionService);
  const didsService = inject(DidsService);
  const pbxService = inject(PBXService);

  return forkJoin({
    users:
      pbxService.getCachedUsers().length > 0
        ? of(pbxService.getCachedUsers())
        : pbxService.getUsers(session.current.pbxId),
    allowedDids:
      didsService.getCachedDids().length > 0
        ? of([])
        : didsService.getAllowedDidsForUser(session.current.pbxId, session.current.companyId, session.current.userId),
  }).pipe(
    tap({
      next: ({ users }) => {
        pbxService.setUsers(users);
      },
      error: () => {
        pbxService.setUsers([]);
        console.log('Failed to fetch users');
      },
    }),
    map(() => void 0)
  );
};
